export default "__VITE_ASSET__D52nC_r$__"